/**
 * matchTelemetry — Minimal match outcome telemetry (SPY-61).
 * Records match length, forfeit flag, and winning team.
 * Application layer — no DOM/Three.js.
 */

/**
 * @param {{ now?: () => number }} [opts]
 * @returns {object}
 */
export function createMatchTelemetry({ now = () => Date.now() } = {}) {
  return {
    now,
    startedAt: 0,
    endedAt: 0,
    recording: false,
    forfeit: false,
    winTeam: null
  };
}

/**
 * @param {object} session
 * @returns {object}
 */
export function startMatchTelemetry(session) {
  const t = session.now();
  session.recording = true;
  session.startedAt = t;
  session.endedAt = 0;
  session.forfeit = false;
  session.winTeam = null;
  return session;
}

/**
 * @param {object} session
 * @param {{ winTeam?: string|null, forfeit?: boolean }} [opts]
 * @returns {{ matchLengthMs: number, forfeit: boolean, winTeam: string|null, recording: boolean }}
 */
export function endMatchTelemetry(session, { winTeam = null, forfeit = false } = {}) {
  session.recording = false;
  session.endedAt = session.now();
  session.forfeit = !!forfeit;
  session.winTeam = winTeam ?? null;
  return buildMatchTelemetryRecord(session);
}

/**
 * @param {object} session
 * @returns {{ matchLengthMs: number, forfeit: boolean, winTeam: string|null, recording: boolean }}
 */
export function buildMatchTelemetryRecord(session) {
  if (!session.startedAt && !session.recording) {
    return {
      matchLengthMs: 0,
      forfeit: !!session.forfeit,
      winTeam: session.winTeam ?? null,
      recording: false
    };
  }
  const end = session.endedAt || session.now();
  return {
    matchLengthMs: Math.max(0, end - session.startedAt),
    forfeit: !!session.forfeit,
    winTeam: session.winTeam ?? null,
    recording: !!session.recording
  };
}
